<template>
  <!--    告警地图    -->
  <div class="alarmMap">
    <hb-frame type="left" :isShowOpenBtn="false" :isShowOpenIcon="true">
      <div class="realtimeLeft" v-loading="false">
        <el-row style="height: 100%">
          <el-col :span="24" v-if="resData">
            <div
              shadow="always"
              class="card"
              v-for="item in resData"
              :key="item.id"
            >
              <alarmImg :item="item" @click="clickAlarmDetial(item)"></alarmImg>
              <div class="border" @click="mapLocation(item)">
                {{ item.deviceName }}
              </div>
            </div>
          </el-col>
          <el-empty description="暂无数据" v-else></el-empty>
        </el-row>
      </div>
      <div class="page">
        <el-pagination
          v-model:currentPage="currentPage"
          v-model:page-size="pageSize"
          :small="small"
          layout="total, jumper"
          :total="totalCount"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </hb-frame>
    <div class="my-map-box">
      <MyMap ref="mapRef" />
    </div>
    <alarmDetailDialog
      v-if="alarmDetailVisible"
      v-model:visible="alarmDetailVisible"
      :itemInfo="alarmDetailItem"
    ></alarmDetailDialog>
    <alarm-dom
      id="mapAlarmDom"
      :itemInfo="mapDataItem"
      v-show="showMapRender"
      @close="close"
      @openDetail="clickAlarmDetial"
    ></alarm-dom>
    <mapArrayPoint
      id="mapArrayPointDom"
      ref="mapArrayPointRef"
      v-show="showArrayPointDom"
      :pointInfo="mapArrayPointData"
      @emitPointClick="getArrayPoint"
      @closeReminder="closeArrayPointDom"
    ></mapArrayPoint>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  onMounted,
  onUnmounted,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import alarmImg from "./alarmImg.vue";
import alarmDom from "./alarmDom.vue";
import { getFindByCondition } from "@/api/alarmCenter/alarmCenter.js";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import util from "@util/js";
import moment from "moment";
export default defineComponent({
  name: "",
  components: { MyMap, alarmImg, alarmDom },
  props: {
    tableParams: {
      type: Object,
      defaule: () => {},
    },
  },
  setup(props) {
    const data = reactive({
      loading: false,
      alarmDetailVisible: false, // 告警详情
      alarmDetailItem: {}, // 告警详情数据
      resData: null,
      totalCount: 0,
      page: 1,
      mapDataItem: null, // 地图提示框信息
      showMapRender: false, // 是否展示地图提示框
      showArrayPointDom: false,
      mapArrayPointData: null,
      queryTime: null,
    });
    const { setVideoPoint, reverseVideoPoint } = handleCoordinates();
    const refData = toRefs(data);
    const mapRef = ref();
    const mapAlarmRef = ref();
    // 添加接口中数据点位
    const pointInfoArray = (list) => {
      const array = list.filter((item, index) => {
        if (item.longitude && item.latitude) {
          item.location = setVideoPoint([
            Number(item.longitude),
            Number(item.latitude),
          ]);
          return item;
        }
      });
      const newList = array.map((element, index) => {
        const pointInfo = {
          name: "",
          item: element,
          id: index + 1,
          type: 1,
          poiType: 3401,
          showType: 2,
          location: element.location,
          click: (e) => {
            data.showArrayPointDom = false;
            if (e.length > 1) {
              handleMapArrayClick(e);
              nextTick(() => {
                data.mapArrayPointData = e.map((item) => {
                  item.values_.item.cameraName = item.values_.item.deviceName;
                  return item;
                });
              });
            } else {
              handleMapIconClick(e);
              nextTick(() => {
                data.mapDataItem = element;
              });
            }
          },
        };
        return pointInfo;
      });
      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker(newList);
      });
    };
    // 展示点位详情
    const handleMapIconClick = (e) => {
      data.showMapRender = true;
      const dom = document.getElementById("mapAlarmDom");
      const pos = e[0].values_.location;
      const drawOption = {
        positioning: "bottom-center",
        offset: [0, -60],
        stopEvent: false,
      };
      console.log(dom, pos, drawOption);
      mapRef.value && mapRef.value.drawPointInfo(dom, pos, drawOption);
    };
    //展示多个点位详情
    const handleMapArrayClick = (e) => {
      data.showArrayPointDom = true;
      const dom = document.getElementById("mapArrayPointDom");
      let pos = e[0].values_.location;
      let drawOption = {
        positioning: "bottom-center",
        offset: [0, -30],
        stopEvent: false,
      };
      mapRef.value && mapRef.value.drawPointInfo(dom, pos, drawOption);
    };
    //聚合点列表点击展示弹框
    const getArrayPoint = (val) => {
      //需要对传过来啊的值做一层包裹适用handleMapIconClick方法
      const e = {
        values_: val,
      };
      mapRef.value && mapRef.value.mapLocation(val.location, 18);
      closeArrayPointDom();
      handleMapIconClick([e]);
      data.mapDataItem = val.item;
    };
    // 关闭地图点位
    const close = () => {
      data.showMapRender = false;
    };
    //关闭多个点位详情
    const closeArrayPointDom = () => {
      data.showArrayPointDom = false;
    };

    const mapLocation = (val) => {
      mapRef.value && mapRef.value.mapLocation(val.location, 14);
    };
    // 跳转页数
    const handleCurrentChange = (val) => {
      data.page = val;
      getFindByConditionAsync();
    };
    // 打开告警详情弹窗
    const clickAlarmDetial = (item) => {
      data.alarmDetailVisible = true;
      data.alarmDetailItem = item;
    };
    // 接口请求
    const getFindByConditionAsync = async () => {
      data.loading = true;
      // const params = {
      //   ...props.tableParams,
      //   limit: 20,
      //   page: data.page,
      // };
      // const res = await getFindByCondition(util.deleteObj(params));
      const tableParams = _.cloneDeep(props.tableParams);
      const paramsFace = { ...tableParams, type: "2" };
      const paramsCar = { ...tableParams, type: "1" };
      const resFace = await getFindByCondition(paramsFace);
      const resCar = await getFindByCondition(paramsCar);
      const arr = [...resFace.page.list, ...resCar.page.list];
      arr.sort((a, b) => {
        let atime = Number(a.alarmTime);
        let btime = Number(b.alarmTime);
        return atime > btime ? 1 : -1;
      });
      if (res.resCar === 0) {
        data.loading = false;
        data.resData = arr.splice(0, 10);
        data.totalCount = arr.splice(0, 10).length;
        pointInfoArray(arr);
      }
    };
    // getFindByConditionAsync();
    onMounted(() => {
      data.queryTime = setInterval(() => {
        getFindByConditionAsync();
      }, 60 * 1000);
    });
    onUnmounted(() => {
      clearInterval(data.queryTime);
    });
    return {
      ...refData,
      moment,
      mapRef,
      handleCurrentChange,
      clickAlarmDetial,
      close,
      mapLocation,
      handleMapArrayClick,
      getArrayPoint,
      closeArrayPointDom,
    };
  },
});
</script>
<style lang="scss" scoped>
.alarmMap {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  .my-map-box {
    z-index: 1;
    flex: 1;
  }
  .realtimeLeft {
    width: 100%;
    height: 95%;
    padding: 0 12px;
    overflow: scroll;
    .card {
      color: #999999;
      margin: 10px 10px;
      span {
        color: #000;
      }
      .border {
        line-height: 32px;
        height: 32px;
        width: 95%;
        background: #5584ff;
        color: #fff;
        text-align: center;
        font-size: 16px;
        margin: 6px auto;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }
  #mapAlarmDom {
    width: 200px;
    height: 200px;
    background: rgba(8, 13, 38, 0.8);
    color: #14d1b3;
    background-size: 100% 100%;
    padding: 10px;
  }
}
</style>
